import React from "react";
import styled from "styled-components";
import { Configuration } from "../../context/ConfigurationContext";

type ContainerProps = {
  borderColor: string;
  backgroundColor: string;
  textColor: string;
  scale: number;
};

const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  bottom: 0;
  font-family: "TeleNeo", sans-serif !important;
  font-size: ${(props) => 4.75 * props.scale + "rem"};
  line-height: ${(props) => 4.75 * props.scale + "rem"};
  height: ${(props) => 6.0 * props.scale + "rem"};
  font-weight: bold;
  padding-left: ${(props) => 1.0 * props.scale + "rem"};
  padding-right: ${(props) => 1.0 * props.scale + "rem"};

  border-top: 5px solid ${(props) => props.borderColor};
  background-color: ${(props) => props.backgroundColor};
  color: ${(props) => props.textColor};
`;

const TextHolder = styled.span`
  font-family: "TeleNeo", sans-serif !important;
`;

type InformationContainerProps = {
  left: string;
  right: string;
  config: Configuration;
};

const InformationContainer: React.FC<InformationContainerProps> = ({ config, left, right }) => {
  return (
    <Container
      borderColor={config.palette.background}
      backgroundColor={config.palette.infoBackground}
      textColor={config.palette.infoText}
      scale={config.scaling.multiplier}
    >
      <TextHolder>{left}</TextHolder>
      <TextHolder>{right}</TextHolder>
    </Container>
  );
};

export default InformationContainer;
